import { render, staticRenderFns } from "./XcIcon.vue?vue&type=template&id=6b2c689a&scoped=true&"
import script from "./XcIcon.vue?vue&type=script&lang=js&"
export * from "./XcIcon.vue?vue&type=script&lang=js&"
import style0 from "./XcIcon.vue?vue&type=style&index=0&id=6b2c689a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c689a",
  null
  
)

export default component.exports